import { render, staticRenderFns } from "./OccurrencesHeaderComponent.vue?vue&type=template&id=3fe11d56&"
import script from "./OccurrencesHeaderComponent.vue?vue&type=script&lang=js&"
export * from "./OccurrencesHeaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports